<template>
  <el-dialog :visible.sync="visible" :title="'参数设置'" :close-on-click-modal="false"
             :close-on-press-escape="false" :append-to-body="true">
    <el-form :model="dataForm"  ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item v-for="keyExplain in keyExplains" :key="keyExplain.key" :prop="keyExplain.key" :label="keyExplain.explain" :rules="{required: true, message: $t('validate.required'), trigger: 'blur'}">
        <el-input v-model="dataForm[keyExplain.key]" :placeholder="keyExplain.explain"  ></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'message-config-params',
  data () {
    return {
      keyExplains: [],
      visible: false,
      templateType: '',
      dataForm: {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        // this.$refs.dataForm.resetFields()
      })
    },
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit('setParams', this.dataForm, this.templateType)
          }
        })
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>

<style scoped>

</style>
